<template>
  <div
    ref="fullscreen"
    class="hospitalFrame"
  >
    <div class="fullscreen">

      <van-button
        v-if="false"
        v-show="isFullscreen"
        type="primary"
        ref="clickFullscreen"
        @click="launchFullscreen"
        size="small"
      >全屏</van-button>
      <van-button
        v-if="false"
        v-show="!isFullscreen"
        type="primary"
        @click="exitFullscreen"
        size="small"
      >退出全屏</van-button>
    </div>
    <div class="remoteVideo">
      <video
        id="remote-video"
        autoplay
      ></video>
      <div
        class="textFull"
        v-if="playStreamList_current.length > 0"
      ><span>{{playStreamList_current[0].user.userName}}</span></div>
    </div>
    <div class="otherVideo">
      <div
        v-for="(item,i) in playStreamList"
        :key="i"
        style="width: 100%;height: 100%;"
      >
        <video
          height="100%"
          :id="'remote-video'+i"
          autoplay
          @click="changeMaxVideo(false, item, i)"
        ></video>
        <div class="text"><span>{{item.user.userName}}</span></div>
      </div>
    </div>
    <div class="localVideo">
      <div>
        <video
          v-show="islocalShow"
          height="100%"
          width="100%"
          id="local-video"
          autoplay
          muted
        ></video>
      </div>
      <div>
        <van-row gutter="8">
          <van-col :span="4">
            <van-button
              type="info"
              @click="chatShow = !chatShow"
              size="small"
            >{{chatShow ? '隐藏聊天':'显示聊天'}}</van-button>
          </van-col>
          <van-col :span="4">
            <van-button
              type="primary"
              @click="selectDoctors"
              size="small"
            >添加医生</van-button>
          </van-col>
          <van-col :span="4">
            <van-button
              type="primary"
              @click="hFullscreen"
              size="small"
            >旋转</van-button>
          </van-col>
          <van-col :span="4">
            <van-button
              type="primary"
              @click="()=>{islocalShow = !islocalShow}"
              size="small"
            >{{islocalShow ? '隐藏' : '显示'}}</van-button>
          </van-col>
          <van-col :span="8">
            <van-button
              type="danger"
              @click="loginout"
              size="small"
              block
            >挂断</van-button>
          </van-col>
        </van-row>

      </div>
    </div>
    <!-- 聊天记录 -->
    <div
      class="chat"
      :class="{'chat-show':chatShow}"
    >
      <div class="chat-main">
        <van-row
          v-for="item in chatMsgList"
          :key="item.id"
        >
          <van-row class="chat-name">
            <div v-if="user.userID !== item.user_id">{{`${item.user_name || item.user_id}    ${item.send_time}`}}</div>
            <div
              v-else
              class="chat-name-me"
            >{{item.send_time}}</div>
          </van-row>
          <van-row>
            <div
              v-if="item.msg_type === 0"
              :class="{'chat-content-me':user.userID === item.user_id,'chat-content':user.userID !== item.user_id}"
            >{{item.msg_content}}</div>
            <div
              v-if="item.msg_type === 1"
              :class="{'chat-content-me':user.userID === item.user_id,'chat-content':user.userID !== item.user_id}"
            >
              <van-image
                fit="scale-down"
                :src="item.msg_content"
                style="max-height: 160px;"
              />
            </div>
          </van-row>
        </van-row>
      </div>
      <van-field
        class="chatMsg"
        v-model="chatMsg"
        rows="3"
        autosize
        type="textarea"
      >
        <template #button>
          <van-row>
            <van-col span="24">
              <van-button
                size="small"
                type="primary"
                @click="send()"
              >发送</van-button>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="24">
              <van-uploader :after-read="uploadImg">
                <!-- <van-button
                  size="small"
                  type="info"
                  icon="photo"
                ></van-button> -->
                <van-button
                  size="small"
                  type="info"
                >图片</van-button>
              </van-uploader>
            </van-col>
          </van-row>
        </template>
      </van-field>
    </div>
    <van-dialog
      v-model="showDoctors"
      width="1000"
      :closeOnClickOverlay="true"
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <van-row>
        <van-col span="8">
          <van-list>
            <van-cell
              v-for="item in provint_data"
              :key="item.id"
              :title="item.name"
              @click="getHospital(item.id)"
            />
          </van-list>
        </van-col>
        <van-col span="8">
          <van-list>
            <van-cell
              v-for="item in hospital_data"
              :key="item.id"
              :title="item.name"
              @click="getDoctor(item.id)"
            />
          </van-list>
        </van-col>
        <van-col span="8">
          <van-list>
            <van-cell
              v-for="item in doctor_data"
              :key="item.id"
              :title="item.fullName"
              @click="joinRoom(item.id,item.fullName)"
              :clickable="true"
            />
          </van-list>
        </van-col>
      </van-row>
    </van-dialog>
  </div>
</template>

<script>
import util from '@/api/util.js';
import moment from 'moment'
import { Dialog, Notify } from 'vant';
import server from '@/api/hospital.js'
import { ZegoExpressEngine } from 'zego-express-engine-webrtc'

export default {
  data () {
    return {
      chatShow: false,
      chatMsg: '',
      chatMsgList: [],
      islocalShow: true,
      isFullscreen: true,
      appID: 1366632694,
      // appSign: '3de4f311516508e401f63b813e865a8d3594490297dc348e2283cf6bc83b762e',
      zg: null,
      // serverUrl: 'wss://webliveroom-test.zego.im/ws',
      serverUrl: 'wss://webliveroom1366632694-api.zego.im/ws',
      user: {},
      roomID: '',
      streamID: '',
      showDoctors: false,
      provint_data: [],
      hospital_data: [],
      doctor_data: [],
      playStreamList_current: [],
      playStreamList: [],
      rotateFullscreen: 0,
      types: '0'
    }
  },
  mounted () {
    this.user = util.userData() || {}
    this.types = this.user.userType == '9' ? '1' : '0'
    this.roomID = this.$route.query.roomID
    this.bCurrentPage = true;
    if (this.roomID) {
      this.createZegoExpressEngine();
      // this.logoutRoom(this.roomID) // 退出系统，存在没有退出房间的情况
      this.loginRoomOption();
      this.initEvent();
      this.getListMsg();
    }
  },
  methods: {
    async enumDevices () {
      const deviceInfo = await this.zg.enumDevices();
      this.audioDeviceList = deviceInfo &&
        deviceInfo.microphones.map((item, index) => {
          if (!item.deviceName) {
            item.deviceName = 'microphone' + index;
          }
          console.log('microphone: ' + item.deviceName);
          return item;
        });
      this.audioDeviceList.push({ deviceID: 0, deviceName: '禁止' });
      this.microphoneDevicesVal = this.audioDeviceList[0].deviceID;
      this.videoDeviceList = deviceInfo &&
        deviceInfo.cameras.map((item, index) => {
          if (!item.deviceName) {
            item.deviceName = 'camera' + index;
          }
          console.log('camera: ' + item.deviceName);
          return item;
        });
      this.videoDeviceList.push({ deviceID: 0, deviceName: '禁止' });
      this.cameraDevicesVal = this.videoDeviceList[0].deviceID;
    },
    initEvent () {
      // 房间状态更新回调
      //this.zg.on('roomStateUpdate', async (roomID, state, errorCode, extendedData) => {
      this.zg.on('roomStateUpdate', async (roomID, state) => {
        if (state == 'CONNECTED') {
          this.streamID = new Date().getTime().toString();
          this.startPublishingStream(this.streamID, 'local-video');
        }
        if (state == 'DISCONNECTED') {
          // 与房间断开了连接
        }

        if (state == 'CONNECTING') {
          // 与房间尝试连接中
        }
      })

      //this.zg.on('roomUserUpdate', (roomID, updateType, userList) => {
      this.zg.on('roomUserUpdate', () => {
        // 其他用户进出房间的通知
      })

      // this.zg.on('roomStreamUpdate', async (roomID, updateType, streamList, extendedData) => {
      this.zg.on('roomStreamUpdate', async (roomID, updateType, streamList) => {
        // 房间内其他用户音视频流变化的通知
        // 当 updateType 为 ADD 时，代表有音视频流新增，此时可以调用 startPlayingStream 接口拉取播放该音视频流
        if (updateType == 'ADD') {
          if (this.playStreamList_current.length === 0) {
            this.playStreamList_current = [{
              ...streamList[0]
            }];
            streamList.splice(0, 1);
            this.playStreamList = streamList;
          } else {
            streamList.forEach(item => {
              this.playStreamList.push(item);
            })
          }
          this.refresh(false)
        } else if (updateType == 'DELETE') {
          let _streamList_current = this.playStreamList_current.filter(item => !streamList.find(i => i.streamID === item.streamID));
          let _streamList = this.playStreamList.filter(item => !streamList.find(i => i.streamID === item.streamID));
          if (_streamList_current.length === 0 && _streamList.length !== 0) {
            // this.changeVideo(0, true)
            this.playStreamList_current = [{ ..._streamList[0] }]
            _streamList.splice(0, 1)
          } else {
            this.playStreamList_current = _streamList_current;
          }
          this.playStreamList = _streamList;
          for (let i = 0; i < streamList.length; i++) {
            // 流删除，通过流删除列表 streamList 中每个流的 streamID 进行停止拉流。
            this.zg.stopPlayingStream(streamList[i].streamID)
          }
          console.log('playStreamList_current', this.playStreamList_current)
          this.refresh(true)
          const This = this;
          // 1秒后 检查房间状态
          setTimeout(() => {
            // 如果返回false 就退出房间
            server.checkRoomOpen(This.roomID).then(res => {
              if (!res.data) { This.loginout() }
            })
          }, 2000)
        }
      })

      //this.zg.on('publisherStateUpdate', (result) => {
      this.zg.on('publisherStateUpdate', () => {
        // 推流状态更新回调
      })

      //this.this.zg.on('publishQualityUpdate', (streamID, stats) => {
      this.zg.on('publishQualityUpdate', () => {
        // 推流质量回调
      })

      // this.zg.on('playerStateUpdate', (result) => {
      this.zg.on('playerStateUpdate', () => {
        // 拉流状态更新回调
        // ...
      })

      //this.zg.on('playQualityUpdate', (streamID, stats) => {
      this.zg.on('playQualityUpdate', () => {
        // 拉流质量回调
      })
    },
    async startPlayingStream (streamID, elementId) {
      // streamList 中有对应流的 streamID
      const remoteStream = await this.zg.startPlayingStream(streamID);
      // remoteVideo为本地<video>或<audio>对象
      const remoteVideo = document.getElementById(elementId);
      // remoteVideo 为 MediaStream 对象，开发者可通过赋值给video或audio标签元素的srcObject属性进行渲染
      remoteVideo.srcObject = remoteStream;
    },
    // 初始化实例
    createZegoExpressEngine () {
      this.zg = new ZegoExpressEngine(this.appID, this.serverUrl);
      this.zg.setDebugVerbose(false) // 关闭Debug模式
    },
    // Step2 Check system requirements
    async checkSystemRequirements () {
      console.log('sdk version is', this.zg.getVersion());
      try {
        const result = await this.zg.checkSystemRequirements();

        console.warn('checkSystemRequirements ', result);

        if (!result.webRTC) {
          console.error('browser is not support webrtc!!');
          return false;
        } else if (!result.videoCodec.H264 && !result.videoCodec.VP8) {
          console.error('browser is not support H264 and VP8');
          return false;
        } else if (!result.camera && !result.microphones) {
          console.error('camera and microphones not allowed to use');
          return false;
        } else if (result.videoCodec.VP8) {
          if (!result.screenSharing) console.warn('browser is not support screenSharing');
        } else {
          console.log('不支持VP8，请前往混流转码测试');
        }
        return true;
      } catch (err) {
        console.error('checkSystemRequirements', err);
        return false;
      }
    },
    // Step3 Login room
    loginRoom (roomId, userId, userName) {
      server.getToken(roomId, userId).then(async (res) => {
        if (res.success) {
          await this.zg.loginRoom(roomId, res.data, { userID: userId, userName }, { userUpdate: true }).then(result => {
            if (result == true) {
              console.log("login success")
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          console.log(res)
        }
      })
    },
    // Step4 Start Publishing Stream
    async startPublishingStream (streamId, elementId) {
      try {
        const localStream = await this.zg.createStream();
        // 获取页面的 video 标签
        const localVideo = document.getElementById(elementId);
        // stream 为MediaStream对象，开发者可通过赋值给video或audio的srcObject属性进行渲染
        localVideo.srcObject = localStream;
        // 开始推流，将自己的音视频流推送到 ZEGO 音视频云
        this.zg.startPublishingStream(streamId, localStream)
        return true;
      } catch (err) {
        return false;
      }
    },
    // 退出房间
    logoutRoom (roomId) {
      this.zg.logoutRoom(roomId);
    },
    clearStream () {
      this.playStreamList_current.forEach((item) => {
        this.zg.stopPlayingStream(item.streamID)
      })
      this.playStreamList.forEach((item) => {
        this.zg.stopPlayingStream(item.streamID)
      })
      this.playStreamList_current = []
      this.playStreamList = []
    },
    async loginRoomOption () {
      try {
        this.isLogin = true;
        await this.loginRoom(this.roomID, this.user.userID, this.user.fullName);
      } catch (err) {
        this.isLogin = false;
        console.log(err);
      }
    },
    loginout () {
      // 医生退出房间
      server.leaveRoom({
        userId: this.user.userID,
        roomId: this.roomID
      }).then(() => {
        this.reset()
        if (this.user.userType == 5 || this.user.userType == 6) {
          util.router("/fb")
        } else {
          util.router("/doctors")
        }

      })
    },
    async reset () {
      if (!this.zg) {
        return
      }
      if (this.isLogin) {
        this.isLogin = false;
        this.logoutRoom(this.roomID);
      }
      this.clearStream();
      this.zg = null;
      window.zg = null;
    },
    // 進入全屏
    launchFullscreen () {
      this.isFullscreen = false
      const element = this.$refs.fullscreen;
      //此方法不可以在異步任務中執行，否則火狐無法全屏
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.oRequestFullscreen) {
        element.oRequestFullscreen();
      }
      else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      } else {

        var docHtml = document.documentElement;
        var docBody = document.body;
        var cssText = 'width:100%;height:100%;overflow:hidden;';
        docHtml.style.cssText = cssText;
        docBody.style.cssText = cssText;
        element.style.cssText = cssText + ';' + 'margin:0px;padding:0px;';
        document.IsFullScreen = true;

      }
    },
    // 退出全屏
    exitFullscreen () {
      this.isFullscreen = true
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.oRequestFullscreen) {
        document.oCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else {
        var docHtml = document.documentElement;
        var docBody = document.body;
        var videobox = document.getElementById('videobox');
        docHtml.style.cssText = "";
        docBody.style.cssText = "";
        videobox.style.cssText = "";
        document.IsFullScreen = false;
      }
    },
    // 横屏全屏
    hFullscreen () {
      let myVideo = document.getElementById('remote-video');
      // myVideo.controls = 'auto';
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      let h = document.documentElement.clientHeight || document.body.clientHeigth;
      //let cha = Math.abs(h - w) / 2;
      myVideo.width = h;
      myVideo.height = w;
      // myVideo.style.zIndex = 2000;
      // myVideo.style.top = 0
      if (this.rotateFullscreen === 270) {
        this.rotateFullscreen = 0
      } else {
        this.rotateFullscreen = this.rotateFullscreen + 90
      }
      myVideo.style.transform = `rotate(${this.rotateFullscreen}deg)`;
    },
    selectDoctors () {
      this.showDoctors = true
      this.getProvintList()
    },
    // 获取省数据
    getProvintList () {
      const data = util.getStorage('ProvintList') || []
      if (data && data.length > 0) {
        this.provint_data = data
        this.getHospital(data[0].id)
      }
      server.getProvintByTypes(this.types).then(res => {
        this.hospital_data = []
        this.provint_data = res.data
        if (res.data && res.data.length > 0 && data.length === 0) {
          this.getHospital(res.data[0].id)
        }
        util.setStorage('ProvintList', res.data)
      })
    },
    // 获取医院数据
    getHospital (provintID) {
      server.getHospital(provintID, this.types).then(res => {
        this.hospital_data = res.data
        this.$forceUpdate()
        if (res.data && res.data.length > 0) {
          this.getDoctor(res.data[0].id)
        } else {
          this.doctor_data = []
          this.$forceUpdate()
        }
      })
    },
    // 获取医生数据
    getDoctor (hospitalID) {
      server.getDoctor(hospitalID, this.types).then(res => {
        this.doctor_data = res.data.filter(t => t.id !== this.user.userID)
      })
    },
    // 获取医生加入房间
    joinRoom (userId, name) {
      server.requestJoinRoom({
        userId: userId,
        roomId: this.roomID
      }).then(res => {
        if (res.data) {
          this.showDoctors = false
          Dialog.alert({ message: `等待 ${name} 医生接入` })
        }
      })
    },
    // 切换大小屏
    changeMaxVideo (islocal, item, i) {
      if (islocal) {
        // 切换到本地视频
        if (this.playStreamList_current.length > 0) {
          this.playStreamList.push({
            ...this.playStreamList_current[0]
          });
          this.$forceUpdate();
        }
        this.playStreamList_current = [];
      } else {
        // 切换到对方视频
        if (this.playStreamList_current.length > 0 && this.playStreamList_current[0].streamID !== item.streamID) {
          this.playStreamList[i] = { ...this.playStreamList_current[0] }
        }
        this.playStreamList_current = [{ ...item }];
      }
      this.changeVideo(i, true)
    },
    changeVideo (index, bChange) {
      const remoteVideo = document.getElementById('remote-video');
      const remoteVideoN = document.getElementById('remote-video' + (index).toString());
      // remoteVideo 为 MediaStream 对象，开发者可通过赋值给video或audio标签元素的srcObject属性进行渲染
      const srcObject = remoteVideo.srcObject
      remoteVideo.srcObject = remoteVideoN.srcObject
      if (bChange) { remoteVideoN.srcObject = srcObject }
      this.$forceUpdate()
    },
    // 刷新
    refresh (bstop) {
      setTimeout(() => {
        this.playStreamList_current.forEach((item) => {
          if (bstop) this.zg.stopPlayingStream(item.streamID)
          this.startPlayingStream(item.streamID, 'remote-video');
        })
        this.playStreamList.forEach((item, i) => {
          if (bstop) this.zg.stopPlayingStream(item.streamID)
          this.startPlayingStream(item.streamID, 'remote-video' + i);
        })
        this.$forceUpdate()
      }, 300);
    },
    // 发送
    send () {
      if (this.chatMsg && this.chatMsg.replace(/\s*/g, "")) {
        this.sendContent({ content: this.chatMsg, types: 0, roomId: this.roomID })
      } else {
        Notify({ type: 'warning', message: '请填写内容再发送' });
      }
    },
    // 上传图片
    uploadImg (data) {
      // 此时可以自行将文件上传至服务器
      server.uploadBase64(data.content.split(';base64,').pop()).then(res => {
        if (res.isSuccess) {
          this.sendContent({ content: res.data, types: 1, roomId: this.roomID })
        } else {
          Notify({ type: 'warning', message: '图片发送失败' });
        }
      }).catch(() => {
        // 主要通知 primary 成功通知 success 危险通知 danger 警告通知 warning
        Notify({ type: 'danger', message: '图片发送失败' });
      })
    },
    sendContent (data) {
      server.send(data).then(res => {
        if (res.isSuccess) { this.getListMsgTime() }
        this.chatMsg = ''
      })
    },
    // 获取聊天记录
    getListMsg () {
      server.getListMsg({ roomId: this.roomID }).then(res => {
        this.chatMsgList = res.data.reverse()
        this.forTimeMsgList()
      })
    },
    // 获取时时聊天记录
    getListMsgTime (bOutTime) {
      let send_time = ''
      if (this.chatMsgList.length > 0) {
        send_time = moment(this.chatMsgList[0].send_time).add(-1, 'seconds').format("YYYY-MM-DD HH:mm:ss")
      }
      server.getListMsg({ roomId: this.roomID, send_time: send_time }).then(res => {
        if (res.isSuccess) {
          for (let i = res.data.length - 1; i >= 0; i--) {
            const c = this.chatMsgList.find(item => item.id === res.data[i].id)
            //if (!c) { this.chatMsgList.splice(0, 0, res.data[i]) }
            if (!c) { this.chatMsgList.push(res.data[i]) }
          }
        }
        if (bOutTime) this.forTimeMsgList()
      }).catch(() => {
        if (bOutTime) this.forTimeMsgList()
      })
    },
    forTimeMsgList (timeout) {
      timeout = timeout || 5000
      window.setTimeout(() => { this.getListMsgTime(true) }, timeout)
    }
  }
}
</script>

<style scoped>
.van-button--small /deep/ {
  width: 100%;
}
.localVideo {
  position: fixed;
  right: 10px;
  bottom: 24px;
  z-index: 1;
  width: 360px;
  height: 255px;
}
.otherVideo {
  position: fixed;
  right: 10px;
  bottom: 275px;
  z-index: 1;
  width: 300px;
}
.otherVideo video {
  width: 300px;
  height: 240px;
}
.localVideo video {
  width: 300px;
  height: 240px;
  margin-left: 60px;
}
.remoteVideo video {
  width: 100vw;
  height: 100vh;
}
.fullscreen {
  position: fixed;
  right: 10px;
  top: 10px;
  z-index: 1;
}
.hospitalFrame {
  overflow: hidden;
  background: rgb(65, 73, 88);
}
.text {
  position: relative;
  text-align: center;
  color: #ffffff;
  background-color: #818075;
  opacity: 0.8;
  width: 300px;
  bottom: 0px;
  top: -3px;
}
.textFull {
  position: absolute;
  text-align: center;
  color: #ffffff;
  background-color: #818075;
  opacity: 0.8;
  width: 100vw;
  bottom: 0px;
}
.chat {
  background-color: #ffffff;
  transition: all 1s;
  transform: translate(-320px, 0px);
  height: 560px;
  width: 320px;
  left: 0px;
  bottom: 0px;
  position: fixed;
  border-top-right-radius: 3px;
}
.chat /deep/ .van-field__control {
  border-radius: 3px;
  padding: 0px 6px;
  background-color: #ffffff;
}
.chat-show {
  transform: translate(0px, 0px);
}
.chat-main {
  width: 100%;
  height: 468px;
  padding: 8px;
  background-color: #ebedf0;
  border-top-right-radius: 3px;
  overflow: auto;
}
.chatMsg {
  background-color: #f2f3f5 !important;
}
.chat-name {
  font-size: 12px;
  color: #6a6a6b;
  margin-bottom: 3px;
}
.chat-name-me {
  float: right;
  font-size: 12px;
  color: #6a6a6b;
  margin-bottom: 3px;
}
.chat-content-me {
  float: right;
  padding: 3px;
  border-radius: 3px;
  background-color: #37f391;
  margin-bottom: 6px;
}
.chat-content {
  float: left;
  padding: 3px;
  border-radius: 3px;
  background-color: #f7f8fa;
  margin-bottom: 6px;
}
</style>
